module.exports = __webpack_public_path__ + "static/media/proj4_img1.f240fc31.jpg";